import { Component, EventEmitter, Input, Output } from '@angular/core';

enum Align {
  Start = 'Start',
  End = 'End',
}

@Component({
  selector: 'modal-dropdown',
  templateUrl: './modal-dropdown.component.html',
  styleUrls: ['./modal-dropdown.component.scss']
})
export class DropdownComponent {
  public readonly Align = Align;

  @Input() alignContent: Align = Align.Start;
  @Input() showDropdown = false;
  @Output() showDropdownChange = new EventEmitter();

  constructor() { }

  onDismiss() {
    this.showDropdownChange.emit(false);
  }

}
